import React, { Component } from 'react';
import { MainLayout } from './layouts/Layout';
import { Home } from './components/Home';

import 'antd/dist/antd.css';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./components/Authentication/login";
import DeviceLookup from "./components/Reports/device-lookup";
import ExecutiveStatsDepartment from "./components/Reports/executive-stats-department";
import ExecutiveStatsEmployee from "./components/Reports/executive-stats-employee";
import EmployeeChecks from "./components/Reports/employee-checks";
import StopLog from "./components/Reports/stoplog";
import StopLogDDACTS from "./components/Reports/stoplog-ddacts";
import StopLogByOfficer from "./components/Reports/stoplog-by-officer";
import WarningReport from "./components/Reports/warning";
import EmployeeDetailChecks from "./components/Reports/employee-detail-checks";
import ICAdmin from "./components/Admin/admin";
import ChatLookup from "./components/Reports/chat-lookup";
import EmployeeHit from "./components/Reports/employee-hit";
import ActivityHit from './components/Reports/activity-hit';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Router>
                <Switch>
                    <Route exact path='/login' component={Login} />
                    <MainLayout>
                        <Route exact path='/' component={Home} />
                        <Route exact path='/icadmin' component={ICAdmin} />
                        <Route exact path='/report/chat-lookup' component={ChatLookup} />
                        <Route exact path='/report/device-lookup' component={DeviceLookup} />
                        <Route exact path='/report/executive-stats-department' component={ExecutiveStatsDepartment} />
                        <Route exact path='/report/executive-stats-employee' component={ExecutiveStatsEmployee} />
                        <Route exact path='/report/activity-hit' component={ActivityHit} />
                        <Route exact path='/report/employee-hit' component={EmployeeHit} />
                        <Route exact path='/report/employee-checks' component={EmployeeChecks} />
                        <Route exact path='/report/employee-detail-checks' component={EmployeeDetailChecks} />
                        <Route exact path='/report/stoplog' component={StopLog} />
                        <Route exact path='/report/stoplog-ddacts' component={StopLogDDACTS} />
                        <Route exact path='/report/stoplog-by-officer' component={StopLogByOfficer} />
                        <Route exact path='/report/warning' component={WarningReport} />
                    </MainLayout>

                </Switch>
            </Router>

        );
    }
}
